import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthService from '../../services/authService';

const ProtectedRoute = () => {
  const user = AuthService.getCurrentUser();

  if (!user || user.is_teacher !== 1) {
    // Not logged in or not a teacher/admin
    return <Navigate to="/dang-nhap" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
